import React, {useState, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import ButtonLink from '../Button';

import ToggleModal from '../../helpers/ToggleModal';

import './index.scss';

import Asset5 from '../../assets/images/Asset5.svg';

function ModalMenu({ onClose }) {
    const { t } = useTranslation(); 
    const { lang } = useParams(); // Получаем текущий язык из URL

    return (
        <div className='modalMenu' id="modalMenu">
            <div className='bodyModal'>
                <div className='list' >
                    <ButtonLink to={`/${lang}/`} className="btn">
                        <span onClick={ToggleModal}>{t('main')}</span>
                    </ButtonLink>
                    <ButtonLink to={`/${lang}/about`} className="btn">
                        <span onClick={ToggleModal}>{t('about')}</span>
                    </ButtonLink>
                    <ButtonLink to={`/${lang}/menu`} className="btn">
                        <span onClick={ToggleModal}>{t('menu')}</span>
                    </ButtonLink>
                    <ButtonLink to={`/${lang}/banquets`} className="btn">
                        <span onClick={ToggleModal}>{t('banquets')}</span>
                    </ButtonLink>
                    <ButtonLink to={`/${lang}/catering`} className="btn">
                        <span onClick={ToggleModal}>{t('catering')}</span>
                    </ButtonLink>
                    <ButtonLink to={`/${lang}/contacts`} className="btn">
                        <span onClick={ToggleModal}>{t('contacts')}</span>
                    </ButtonLink>
                </div>

                <div className='info'>
                    <div className='layer f'>
                        <span>Stationsweg 14, </span>
                        <span>1815CC </span>
                        <span>{t('alkmaar')} </span>
                        <span>{t('nederlands')}</span>
                    </div>
                    <div className='layer f'>
                        <a href={`tel:+3161725203013`} style={{color:"currentcolor", textDecoration:"none"}}>072 5203013</a>
                    </div>
                    <div className='layer f'>
                        <span>&#105;&#110;&#102;&#111;&#64;&#98;&#111;&#114;&#115;&#99;&#104;&#116;&#46;&#110;&#108;</span>
                    </div>
                </div>

                <div className='end'>
                    <img src={Asset5} alt=''/>
                    <span>in Borscht we trust</span>
                    <div className='icons'>
                        <a href="https://www.facebook.com/share/1DtL5rPEJQ/?mibextid=LQQJ4d" target="_blank"><div className='icon fb'></div></a>
                        <a href="https://www.instagram.com/borscht_nl?igsh=anJkdmFlY3Z4ZXF2&utm_source=qr" target="_blank"><div className='icon insta'></div></a>
                    </div>
                </div>
            </div>
        </div>
    );
  }
  
export default ModalMenu;